/**
 * This content search module works on top of "PCG.UmbracoPlugins.ElasticSearch" plugin.
 * It is used on the "County Council" site and other subsites.
 */

import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";
import { NouisliderModule } from "ng2-nouislider";

import { DateFilterComponent } from "./components/date-filter/date-filter.component";
import { CheckboxComponent } from "./components/search-filter/checkbox/checkbox.component";
import { SearchFilterComponent } from "./components/search-filter/search-filter.component";
import { SearchMessageComponent } from "./components/search-message/search-message.component";
import { ResultItemComponent } from "./components/search-results/result-item/result-item.component";
import { SearchResultsComponent } from "./components/search-results/search-results.component";
import { ContentSearchComponent } from "./content-search.component";

@NgModule({
    declarations: [
        CheckboxComponent,
        SearchMessageComponent,
        SearchFilterComponent,
        DateFilterComponent,
        ContentSearchComponent,
        ResultItemComponent,
        SearchResultsComponent
    ],
    exports: [ContentSearchComponent],
    imports: [
        CommonComponentsModule,
        NouisliderModule
    ]
})
export class ContentSearchModule {
}
